<template lang="pug">
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
		<defs>
			<path id="ywmi1s0nta" d="M11.421 10.13h-.68l-.24-.232c1.032-1.204 1.565-2.847 1.273-4.594-.405-2.391-2.4-4.301-4.81-4.594C3.327.263.264 3.326.71 6.965c.293 2.409 2.203 4.404 4.594 4.809 1.747.292 3.39-.241 4.594-1.273l.233.24v.68l3.656 3.656c.353.353.93.353 1.282 0 .353-.352.353-.929 0-1.281L11.42 10.13zm-5.162 0c-2.142 0-3.871-1.729-3.871-3.87 0-2.143 1.729-3.872 3.871-3.872s3.872 1.729 3.872 3.871-1.73 3.872-3.872 3.872z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g transform="translate(-893 -42) translate(831 42) translate(62)">
						<path fill="#D8D8D8" fill-opacity="0" d="M0 0H16V16H0z"/>
						<mask id="cr2fae33bb" fill="#fff">
							<use xlink:href="#ywmi1s0nta"/>
						</mask>
						<use fill="#000" fill-rule="nonzero" xlink:href="#ywmi1s0nta"/>
						<g fill="#FFF" fill-rule="nonzero" mask="url(#cr2fae33bb)">
							<path d="M0 0H16V16H0z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>

</template>

<style lang="stylus" scoped>

</style>

<script>
export default {

}
</script>
